exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-question-study {\n  margin: 16px 0;\n}\n.ai-question-study .ant-form-item {\n  display: flex;\n}\n.ai-question-study .ant-form-item-control-wrapper {\n  flex: 1;\n}\n", ""]);

// exports
